
// custom-option.ts
import { ToastOptions } from 'ng2-toastr';

export class CustomOption extends ToastOptions {
  toastLife = 2000;
}


import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MobilePatternDirective } from './app.component.validator';

import { AboutComponent } from './app.about.component';
import { CardDeleteModalComponent } from './app.confirm.deleteCard.modal.compnent';
import { SessionDeleteModalComponent } from './app.confirm.deleteSession.modal.compnent';
import { NotificationModalComponent } from './app.notification.modal.compnent';
import { HelpNotificationModalComponent } from './app.help.notificationModal.compnent';




import { HomeComponent } from './app.home.component';
import { AppComponent } from './app.component';
import { SignupComponent } from './signin/app.signup.component';
import { CardComponent } from './card/app.card.component';
import { CardModalComponent } from './card/app.card.modal.component';
import { SelectDayModalComponent } from './app.selectDayModal.component';
import { FocusDirective } from './app.focus.directive';

import { MaterialClockComponent } from './materialClock.ng2';


import { HashLocationStrategy, Location, LocationStrategy } from '@angular/common';

import { ProfileComponent } from './profile.component';
import { NumbersToPersianPipe } from './app.pipe';
import { DayFilterPipe } from './app.pipe';



import { DateToPersian } from './app.pipe';

import { WeekFilterPipe } from './app.pipe';
import { MonthFilterPipe } from './app.pipe';
import { YearFilterPipe } from './app.pipe';

import { SafeHtmlPipe } from './app.pipe';

import { Injectable } from '@angular/core';
import { Routing } from './app.routes';

import { ContainerWheelDirective } from './app.mousewheel.directive';
import { ListWheelDirective } from './app.mousewheel.directive';


import { ResponseInterceptor } from './HttpInterceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { enableProdMode } from '@angular/core';
enableProdMode();

// export function httpFactory(backend: XHRBackend, options: RequestOptions) {
//   return new HttpInterceptor(backend, options);
// }

export let requestCounter = 0;


@NgModule({
  declarations: [
    AppComponent, ContainerWheelDirective, HelpNotificationModalComponent,
    ListWheelDirective, SignupComponent, CardComponent, NumbersToPersianPipe, DateToPersian,
    CardDeleteModalComponent, SessionDeleteModalComponent, NotificationModalComponent, AboutComponent,
    ProfileComponent, DayFilterPipe, YearFilterPipe, MonthFilterPipe, WeekFilterPipe, HomeComponent, MobilePatternDirective, SafeHtmlPipe,
    CardModalComponent, MaterialClockComponent, SelectDayModalComponent, FocusDirective,
  ],
  imports: [
    BrowserModule, CommonModule,
    Routing, HttpClientModule, ReactiveFormsModule, FormsModule, ToastModule.forRoot(), BrowserAnimationsModule

  ],

  providers: [Title,
    [{
      provide: HTTP_INTERCEPTORS, useClass:
      ResponseInterceptor, multi: true
    }, {
      provide: ToastOptions, useClass: CustomOption
    }, {
      provide: LocationStrategy, useClass: HashLocationStrategy

    }]
  ],
  bootstrap: [AppComponent]
})



export class AppModule { }



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.module.ts